module.exports = {
  src: __webpack_public_path__ + "logo-download-49f23ca9507ac51fbf8fc36ca862ef97.svg",
  width: 89,
  height: 74,
  bytes: 12155,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-download-49f23ca9507ac51fbf8fc36ca862ef97.svg";
};